<template>
  <section class="plaindetails-area">
    <div class="container">
      <div :class="['plaindetails-box', `bnf-flight-${type}`]" v-if="type === 'depature'">
        <h5 class="text-center" v-if="type === 'depature'">{{ $t("flight-only.round-trip-departure") }}</h5>
        <figure class="logo"><img :src="markAirline" alt="" title="" /></figure>
        <div class="plain-date">
          <div class="d-flex justify-content-between align-items-center">
            <div class="box">
              <h4>{{ departDate }}</h4>
              <h3>{{ departHour }}</h3>
              <h4>{{ fromDestName }}</h4>
            </div>
            <figure class="flight-box">
              <img :src="`${speedSizeDomain}/assets/img/app/flight-img1.png`" alt="#" title="" />
            </figure>
            <div class="box">
              <h4>{{ arriveDate }}</h4>
              <h3>{{ arriveHour }}</h3>
              <h4>{{ toDestName }}</h4>
            </div>
          </div>
        </div>
        <p><span>{{ fromAirportName }}<br/>{{ airlineNumber }}</span></p>
        <ul class="departure-list">
          <li>{{ $t("flight-only.departure-message", {time: departHour, date: departDate, airport: fromAirportName, terminal: fromTerminal}) }}</li>
          <li v-if="isConnectFlight">{{ stopoverMessage }}</li>
          <li v-if="isConnectFlight">{{ $t("flight-only.landing-message-via", { viaRouteName, viaDepTime, time: arriveHour, date: arriveDate, airport: arriveAirportName, terminal: arriveTerminal}) }}</li>
          <li v-else>{{ $t("flight-only.landing-message", { time: arriveHour, date: arriveDate, airport: arriveAirportName, terminal: arriveTerminal }) }}</li>
        </ul>
        <div class="btn-box bnf-hide-dup-flight-no">
          <button class="btn-primary" v-if="data && data.Authorization_msg.includes('לא אושרו')">{{ $t("flight-only.flight-no") }}: N/A</button>
          <button class="btn-primary" v-else>{{ $t("flight-only.flight-no") }}: {{ airlineNumber }}</button>
        </div>
        <div class="baggagedetails-box">
          <h4>{{ $t("flight-only.baggage-details-title") }}</h4>
          <ul>
              <li v-if="suitcaseCostIncluded">
                  <img :src="`${speedSizeDomain}/assets/img/img11.png`" alt="suitcase" class="img" />
                  {{$t("flight-only.suitcase-included", {weight: maxSuitcaseWeight})}}
              </li>
              <li v-else>
                  <img :src="`${speedSizeDomain}/assets/img/img11-no.png`" alt="suitcase" class="img" />
                  {{$t("flight-only.suitcase-not-included", {weight: maxSuitcaseWeight})}}
              </li>
              <li v-if="trolleyCostIncluded">
                  <img :src="`${speedSizeDomain}/assets/img/img12.png`" alt="trolley" class="img" />
                  {{$t("flight-only.trolley-included", {weight: maxTrolleyWeight})}}
              </li>
              <li v-else>
                  <img :src="`${speedSizeDomain}/assets/img/img14.png`" alt="trolley" class="img" />
                  {{$t("flight-only.trolley-not-included")}}
              </li>
          </ul>
        </div>
        <div class="btn-box btn-box2">
          <button class="btn-primary">{{ authorMessage }}</button>
        </div>
      </div>
      <div :class="['plaindetails-box', `bnf-flight-${type}`]" v-else>
        <h5 class="text-center" v-if="type === 'return'">{{ $t("flight-only.round-trip-return") }}</h5>
        <figure class="logo"><img :src="markAirline" alt="" title="" /></figure>
        <div class="plain-date">
          <div class="d-flex justify-content-between align-items-center">
            <div class="box">
              <h3>{{ arriveDate }}</h3>
              <h3>{{ arriveHour }}</h3>
              <h4>{{ toDestName }}</h4>
            </div>
            <figure class="flight-box">
              <img class="arrive" :src="`${speedSizeDomain}/assets/img/app/flight-img1.png`" alt="#" title="" />
            </figure>
            <div class="box">
              <h3>{{ departDate }}</h3>
              <h3>{{ departHour }}</h3>
              <h4>{{ fromDestName }}</h4>
            </div>
          </div>
        </div>
        <p><span>{{ arriveAirportName }}<br/>{{ airlineNumber }}</span></p>
        <ul class="departure-list">
          <li>{{ $t("flight-only.departure-message", {time: departHour, date: departDate, airport: fromAirportName, terminal: fromTerminal}) }}</li>
          <li v-if="isConnectFlight">{{ stopoverMessage }}</li>
          <li v-if="isConnectFlight">{{ $t("flight-only.landing-message-via", { viaRouteName, viaDepTime, time: arriveHour, date: arriveDate, airport: arriveAirportName, terminal: arriveTerminal}) }}</li>
          <li v-else>{{ $t("flight-only.landing-message", { time: arriveHour, date: arriveDate, airport: arriveAirportName, terminal: arriveTerminal }) }}</li>
        </ul>
        <div class="btn-box bnf-hide-dup-flight-no">
          <button class="btn-primary" v-if="data && data.Authorization_msg.includes('לא אושרו')">{{ $t("flight-only.flight-no") }}: N/A</button>
          <button class="btn-primary" v-else>{{ $t("flight-only.flight-no") }}: {{ airlineNumber }}</button>
        </div>
        <div class="baggagedetails-box">
          <h4>{{ $t("flight-only.baggage-details-title") }}</h4>
          <ul>
              <li v-if="suitcaseReturnCostIncluded">
                  <img :src="`${speedSizeDomain}/assets/img/img11.png`" alt="suitcase" class="img" />
                  {{$t("flight-only.suitcase-included", {weight: maxSuitcaseWeight})}}
              </li>
              <li v-else>
                  <img :src="`${speedSizeDomain}/assets/img/img11-no.png`" alt="suitcase" class="img" />
                  {{$t("flight-only.suitcase-not-included", {weight: maxSuitcaseWeight})}}
              </li>
              <li v-if="trolleyReturnCostIncluded">
                  <img :src="`${speedSizeDomain}/assets/img/img12.png`" alt="trolley" class="img" />
                  {{$t("flight-only.trolley-included", {weight: maxTrolleyWeight})}}
              </li>
              <li v-else>
                  <img :src="`${speedSizeDomain}/assets/img/img14.png`" alt="trolley" class="img" />
                  {{$t("flight-only.trolley-not-included")}}
              </li>
          </ul>
        </div>
        <div class="btn-box btn-box2">
          <button class="btn-primary">{{ authorMessage }}</button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import gMixin from '@/utils/mixins';
import imageUrlMixin from '@/utils/imageUrlMixin';

export default {
  mixins: [gMixin, imageUrlMixin],
  props: {
    type: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: null,
    },
    airInfo: {
      type: Object,
      default: null,
    },
    baggagePriceInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      markAirline: `${this.speedSizeDomain}/assets/img/flying.png`,
    };
  },
  computed: {
    ...mapGetters({
      category: 'GET_CURRENT_CATEGORY',
      lang: 'GET_LANGUAGE',
    }),
    airlineName() {
      return this.data?.arl_Name ?? '';
    },
    fromRoute() {
      return this.data?.FL_From_Route ?? '';
    },
    fromDestName() {
      return this.getCityName(this.fromRoute);
    },
    departHour() {
      return this.getTimeFormatDirectly(this.data?.FL_Dep_Hour ?? '');
    },
    departDate() {
      return this.data ? this.getDateFormat(this.data?.FL_Date) : '';
    },
    departWeek() {
      return this.data ? this.getWeek(this.data?.FL_Date) : '';
    },
    fromAirportName() {
      return this.getAirportName(this.data?.FL_From_Air_Port || '');
    },
    toRoute() {
      return this.data?.FL_To_Route ?? '';
    },
    toDestName() {
      return this.getCityName(this.toRoute);
    },
    isConnectFlight() {
      return !!this.data?.FL_Via_Air_Port;
    },
    viaRouteName() {
      return this.getCityName(this.data?.FL_Flt_Via || '');
    },
    viaAirPortName() {
      return this.getAirportName(this.data?.FL_Via_Air_Port || '');
    },
    viaTerminal() {
      return this.data?.FL_Via_Terminal ?? '';
    },
    viaLandTime() {
      return this.data?.FL_ViaDep_Hour || false ? this.getTimeFormat(this.data.FL_Via_Hour) : '';
    },
    viaDepTime() {
      return this.data?.FL_ViaDep_Hour || false ? this.getTimeFormat(this.data.FL_ViaDep_Hour) : '';
    },
    viaStopTimeHours() {
      if (!this.data) return 0;
      return Number(this.data.stopOverTime.split(':')[0]);
    },
    viaStopTimeMinutes() {
      if (!this.data) return 0;
      return Number(this.data.stopOverTime.split(':')[1]);
    },
    arriveHour() {
      return this.getTimeFormatDirectly(this.data?.FL_Arrv_Hour ?? '');
    },
    arriveDate() {
      return this.data ? this.getDateFormat(this.data.landingDate) : '';
    },
    arriveWeek() {
      return this.data ? this.getWeek(this.data.landingDate) : '';
    },
    arriveAirportName() {
      return this.getAirportName(this.data?.FL_To_Air_Port || '');
    },
    airlineNumber() {
      return this.data ? `${this.data.FL_AIRLINE} - ${this.data.FL_Flt_Number}` : '';
    },
    authorMessage() {
      return this.data ? this.data.Authorization_msg : '';
    },
    fromTerminal() {
      return this.stringTerminal(this.data?.FL_From_Terminal || 'N/A');
    },
    arriveTerminal() {
      return this.stringTerminal(this.data?.FL_To_Terminal || 'N/A');
    },
    maxSuitcaseWeight() {
      return this.data?.FL_Max_Weight || 20;
    },
    maxTrolleyWeight() {
      return +this.data?.FL_Max_Weight_Trolley || 0;
    },
    stopoverMessage() {
      if (this.viaStopTimeHours > 0 && this.viaStopTimeMinutes > 0) {
        return this.$t('flight-only.stopover-message', {
          city: this.viaAirPortName,
          hours: this.viaStopTimeHours,
          minutes: this.viaStopTimeMinutes,
        });
      } else if (this.viaStopTimeHours > 0) {
        return this.$t('flight-only.stopover-message-hours-only', {
          city: this.viaAirPortName,
          hours: this.viaStopTimeHours,
        });
      } else if (this.viaStopTimeMinutes > 0) {
        return this.$t('flight-only.stopover-message-minutes-only', {
          city: this.viaAirPortName,
          minutes: this.viaStopTimeMinutes,
        });
      }
      return '';
    },
    trolleyCostIncluded() {
      if (!this.baggagePriceInfo) return true;
      return (this.baggagePriceInfo.trolleyPrice === null);
    },
    trolleyReturnCostIncluded() {
      if (!this.baggagePriceInfo) return true;
      return (this.baggagePriceInfo.trolleyReturnPrice === null);
    },
    suitcaseCostIncluded() {
      if (!this.baggagePriceInfo) return true;
        return (this.baggagePriceInfo.suitcasePrice === null);
    },
    suitcaseReturnCostIncluded() {
      if (!this.baggagePriceInfo) return true;
      return (this.baggagePriceInfo.suitcasePrice === null);
    },
  },
  watch: {
    airInfo() {
      if (!!this.airInfo && this.airInfo.desc2 !== '' && this.airInfo.desc2 !== undefined) {
        this.markAirline = this.airInfo.desc2 || `${this.speedSizeDomain}/assets/img/flying.png`;
      }
    },
  },
  beforeMount() {
  },
  created() {
    if (!!this.airInfo && this.airInfo.desc2 !== '' && this.airInfo.desc2 !== undefined) {
      this.markAirline = this.airInfo.desc2 || `${this.speedSizeDomain}/assets/img/flying.png`;
    }
  },
  methods: {
    getDateFormat(str) {
      return dayjs(str).format('DD.MM.YY');
    },
    getTimeFormat(str) {
      return dayjs(str).format('HH:mm');
    },
    getTimeFormatDirectly(str) {
      return dayjs(`${new Date().toISOString().split('T')[0]}T${str}`).format('HH:mm');
    },
    getDateTimeFormat(str) {
      return dayjs(str).format('DD.MM.YY hh:mm A');
    },
    getWeek(str) {
      const week = [
        this.$t('weekAllName.sun'),
        this.$t('weekAllName.mon'),
        this.$t('weekAllName.tue'),
        this.$t('weekAllName.wed'),
        this.$t('weekAllName.thu'),
        this.$t('weekAllName.fri'),
        this.$t('weekAllName.sat'),
      ];
      return week[dayjs(str).day()];
    },
    getCityName(code) {
      return this.data?.translations?.flightDestinationName?.[code]?.[this.lang] ?? code;
    },
    getAirportName(code) {
      return this.data?.translations?.airportName[code]?.[this.lang] ?? code;
    },
    stringTerminal(pTerminal) {
      return pTerminal !== 'N/A' ? `( ${this.$t('flight-only.terminal')} ${pTerminal} )` : '';
    },
    showFlightDetail() {
      this.showDetailFlag = true;
    },
    closeDetailPopup() {
      this.showDetailFlag = false;
    },
  },
};
</script>
<style lang="less" scoped>
  .bonauf-desktop {
    .plaindetails-area {
      .plaindetails-box {
        max-width: 730px !important;
        margin: auto;

        .departure-list {
          li::after {
            top: -7px;
            right: 8px;
            width: 35px;
            height: 35px;
          }
        }
      }
    }
  }
  img.return-air {
    transform: rotate(180deg);
  }
  .flight_box_baggage_body .flight_box_one_div .img_icon img {
    width: 50%;
    height: auto;
  }
  @media (max-width: 768px) {
    .flight_only_area .flight_only_body .flight_box_one .left_box .flight_icon {
      top: 0;
    }
    .flight_only_area .flight_only_body .flight_box_one .right_box .right_box_one .icon_derection {
      margin-top: -0.3rem;
    }
    .plaindetails-box h5 {
      width: 100%;
      padding: 0;
      margin: 0 0 15px;
      color: #000000;
      font-family: 'FbCoherentiSansBold';
      font-size: 25px;
    }
  }

  /* ====================================================================== */
  /* R5 Batch 7+10: Premium restyle for FlightBoxOneApp (flight-only product) */
  /* ====================================================================== */
  .plaindetails-area .plaindetails-box {
    background: #ffffff !important;
    border: 1px solid #e3e9f1 !important;
    border-radius: 14px !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
    padding: 18px 16px !important;
    margin: 14px auto !important;
    max-width: 480px !important;
    background-image: none !important;
    font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  }
  /* All text inside inherits the right font + crisp colors */
  .plaindetails-area .plaindetails-box,
  .plaindetails-area .plaindetails-box * {
    font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  }
  /* Direction header — "טיסת הלוך" / "טיסת חזור" — brand-themed strip on top */
  .plaindetails-area .plaindetails-box h5.text-center {
    display: flex !important;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin: -18px -16px 14px !important;
    padding: 10px 14px !important;
    border-top-left-radius: 14px !important;
    border-top-right-radius: 14px !important;
    font-size: 14px !important;
    font-weight: 700 !important;
    text-transform: none;
    width: auto !important;
  }
  /* Outbound (depature) — coral/orange accent */
  .plaindetails-area .plaindetails-box.bnf-flight-depature h5.text-center {
    background: linear-gradient(90deg, #fff4ec 0%, #ffe6d3 100%) !important;
    color: #b94a18 !important;
    border-top: 3px solid #fb6d2f;
  }
  /* Return — cool blue accent (consistent with R3 SingleFlightItemApp) */
  .plaindetails-area .plaindetails-box.bnf-flight-return h5.text-center {
    background: linear-gradient(90deg, #eef6ff 0%, #d6e9ff 100%) !important;
    color: #1c4e80 !important;
    border-top: 3px solid #1c7ed6;
  }

  /* KILL all legacy timeline decorations on departure-list:
     - ul::before / ul::after = the vertical dotted line on the right
     - li::before / li::after = the round circles per item
     These were bleeding from bonaufApp.css and overlapping the text. */
  .plaindetails-area .plaindetails-box .departure-list,
  .plaindetails-area .plaindetails-box ul.departure-list {
    position: static !important;
  }
  .plaindetails-area .plaindetails-box .departure-list::before,
  .plaindetails-area .plaindetails-box .departure-list::after,
  .plaindetails-area .plaindetails-box ul.departure-list::before,
  .plaindetails-area .plaindetails-box ul.departure-list::after,
  .plaindetails-area .plaindetails-box .departure-list li::before,
  .plaindetails-area .plaindetails-box .departure-list li::after,
  .plaindetails-area .plaindetails-box ul.departure-list li::before,
  .plaindetails-area .plaindetails-box ul.departure-list li::after {
    display: none !important;
    content: none !important;
    background: none !important;
    border: none !important;
    width: 0 !important;
    height: 0 !important;
  }
  /* Reset the padding-right that was making room for the now-hidden circles */
  .plaindetails-area .plaindetails-box .departure-list li,
  .plaindetails-area .plaindetails-box ul.departure-list li {
    padding-right: 0 !important;
    padding-left: 0 !important;
    position: static !important;
    font-family: 'ploni', 'Poppins', 'Segoe UI', Tahoma, Arial, sans-serif !important;
  }

  /* Premium plane-date row — bigger times, muted dates */
  .plaindetails-area .plaindetails-box .plain-date .box h3 {
    font-size: 22px !important;
    font-weight: 700 !important;
    color: #0e436b !important;
    margin: 4px 0 !important;
  }
  .plaindetails-area .plaindetails-box .plain-date .box h4 {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: #475569 !important;
    margin: 0 !important;
  }

  /* Carrier name + flight code — premium dual-line chip (R5 B30) */
  .plaindetails-area .plaindetails-box > p {
    text-align: center;
    margin: 16px auto 8px !important;
    line-height: 1.4;
  }
  .plaindetails-area .plaindetails-box > p span {
    display: inline-flex !important;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px 18px;
    background: linear-gradient(135deg, #eef6ff 0%, #d6e9ff 100%);
    border: 1px solid #cfe2ff;
    border-radius: 14px;
    font-size: 12px;
    font-weight: 500;
    color: #1c4e80;
    box-shadow: 0 2px 6px rgba(28, 126, 214, 0.12);
    line-height: 1.3;
    min-width: 200px;
  }
  /* The first text-node (airport name) gets normal weight, the <br/>
     separates it from the second line (flight number) which we make bold. */
  .plaindetails-area .plaindetails-box > p span br + * {
    font-weight: 700;
    color: #0e436b;
    font-size: 14px;
  }

  /* Hide the duplicate "מספר הטיסה" button — flight number already shown
     in the chip above (R5 B30 — user reported duplication) */
  .plaindetails-area .plaindetails-box .btn-box.bnf-hide-dup-flight-no {
    display: none !important;
  }

  /* Departure list — refined ordered list */
  .plaindetails-area .plaindetails-box .departure-list {
    list-style: none !important;
    margin: 14px 0 !important;
    padding: 12px 14px !important;
    background: #f7faff;
    border: 1px solid #e1e9f5;
    border-radius: 10px;
    font-size: 13px;
    color: #475569;
    line-height: 1.5;
  }
  .plaindetails-area .plaindetails-box .departure-list li {
    padding: 4px 0;
    border-bottom: 1px dashed #e3e9f1;
  }
  .plaindetails-area .plaindetails-box .departure-list li:last-child {
    border-bottom: none;
  }

  /* Replace orange/yellow gradient buttons with clean badges */
  .plaindetails-area .plaindetails-box .btn-box {
    display: flex;
    justify-content: center;
    margin: 12px 0 !important;
  }
  .plaindetails-area .plaindetails-box .btn-box .btn-primary {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    padding: 6px 16px !important;
    background: #f1f5f9 !important;
    background-image: none !important;
    color: #0e436b !important;
    border: 1px solid #cfd8e3 !important;
    border-radius: 999px !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    box-shadow: none !important;
    cursor: default !important;
    pointer-events: none;
    width: auto !important;
    height: auto !important;
    min-height: 0 !important;
  }
  /* "Authorized" badge (btn-box2) — green tint */
  .plaindetails-area .plaindetails-box .btn-box.btn-box2 .btn-primary {
    background: #ecfdf5 !important;
    color: #047857 !important;
    border-color: #a7f3d0 !important;
  }

  /* ===== R5 B27: Premium baggage list — refined card design ===== */
  .plaindetails-area .plaindetails-box .baggagedetails-box {
    margin: 16px 0 8px !important;
    padding: 14px 16px !important;
    background: linear-gradient(180deg, #f7faff 0%, #f0f5fc 100%);
    border: 1px solid #e1e9f5;
    border-radius: 14px;
  }
  .plaindetails-area .plaindetails-box .baggagedetails-box h4 {
    font-size: 14px !important;
    font-weight: 700 !important;
    color: #1c4e80 !important;
    margin: 0 0 12px !important;
    padding-bottom: 10px;
    border-bottom: 1px dashed #d8e3f0;
    display: flex !important;
    align-items: center;
    gap: 8px;
  }
  .plaindetails-area .plaindetails-box .baggagedetails-box h4::before {
    content: '🧳';
    font-size: 16px;
  }
  .plaindetails-area .plaindetails-box .baggagedetails-box ul {
    list-style: none !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  /* Each row: icon-circle on right, text in middle (flex:1), green ✓ pill on left */
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li {
    display: flex !important;
    align-items: center;
    gap: 10px;
    padding: 10px 12px !important;
    background: #ffffff;
    border: 1px solid #c8e6c9;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 500;
    color: #1f4d2e;
    line-height: 1.35;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    position: relative;
    overflow: hidden;
    padding-left: 76px !important;  /* room for the "כלול" badge */
  }
  /* Icon goes into a colored circle (right side in RTL) */
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li img.img {
    width: 36px !important;
    height: 36px !important;
    object-fit: contain;
    flex: 0 0 36px;
    padding: 6px;
    background: #f0fdf4;
    border: 1px solid #c8e6c9;
    border-radius: 50%;
    box-shadow: 0 1px 2px rgba(40, 167, 69, 0.12);
  }
  /* Add "כלול" badge as ::after on each li (left side in RTL) */
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li::after {
    content: '✓ כלול';
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    background: linear-gradient(135deg, #28a745 0%, #1e7e34 100%);
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 999px;
    box-shadow: 0 2px 4px rgba(40, 167, 69, 0.25);
    letter-spacing: 0.3px;
    white-space: nowrap;
  }
  /* Items with "no" icon (not included) — amber design */
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li:has(img[src*="11-no"]),
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li:has(img[src*="img14"]) {
    background: #fffbf3;
    border-color: #ffd97a;
    color: #6c4a00;
  }
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li:has(img[src*="11-no"]) img.img,
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li:has(img[src*="img14"]) img.img {
    background: #fff8e1;
    border-color: #ffd97a;
    box-shadow: 0 1px 2px rgba(146, 64, 14, 0.12);
  }
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li:has(img[src*="11-no"])::after,
  .plaindetails-area .plaindetails-box .baggagedetails-box ul li:has(img[src*="img14"])::after {
    content: '+ בעלות';
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    box-shadow: 0 2px 4px rgba(217, 119, 6, 0.25);
  }

  /* Flight box icon (airplane in middle) — tinted */
  .plaindetails-area .plaindetails-box .plain-date .flight-box img {
    width: 60px !important;
    height: 30px !important;
    object-fit: contain;
    opacity: 0.85;
  }

  /* Plain-date layout — better spacing */
  .plaindetails-area .plaindetails-box .plain-date {
    margin: 6px 0 !important;
    padding: 8px 4px !important;
  }
  .plaindetails-area .plaindetails-box .plain-date .box {
    flex: 1;
    text-align: center;
  }

  /* Hide the airline logo if too big — keep responsive */
  .plaindetails-area .plaindetails-box figure.logo {
    text-align: center;
    margin: 0 0 4px !important;
  }
  .plaindetails-area .plaindetails-box figure.logo img {
    max-height: 32px !important;
    width: auto !important;
  }
</style>
